import Span from "./span"
import Text from "./text"
import Title from "./title"

export { Span, Text, Title }
